import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { UserRolesIds } from '@models';
import { Store } from '@ngrx/store';
import { AuthSelectors } from '@ngrx-store';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard {
  constructor(private store: Store, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot) {
    const activeForAdmin = route.data['activeForAdmin'];

    return this.store.select(AuthSelectors.userRole).pipe(
      tap(async userRole => {
        if (userRole === UserRolesIds.ReadOnly || (userRole === UserRolesIds.ClientAdmin && !activeForAdmin)) {
          await this.router.navigateByUrl('dashboard');
        }
      }),
    );
  }
}
